import { render, staticRenderFns } from "./Vector.vue?vue&type=template&id=89995d1c&scoped=true"
import script from "./Vector.vue?vue&type=script&lang=js"
export * from "./Vector.vue?vue&type=script&lang=js"
import style0 from "./Vector.vue?vue&type=style&index=0&id=89995d1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89995d1c",
  null
  
)

export default component.exports